import script from "./LegalAcceptanceBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalAcceptanceBanner.vue?vue&type=script&setup=true&lang=js"

import "./LegalAcceptanceBanner.vue?vue&type=style&index=0&id=a1dcb6ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1dcb6ac"]])

export default __exports__